"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextEditor = void 0;
var ckeditor4_react_1 = require("ckeditor4-react");
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var constants_1 = __importDefault(require("../../constants"));
var MessageHelper_1 = require("../Common/MessageHelper");
var EditorStyles_1 = require("./EditorStyles");
var GlobalCKEStyle = (0, styled_components_1.createGlobalStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), EditorStyles_1.GlobalStyle);
var RichTextEditorContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", " \n\t", "\n\t.tws-rte-editor {\n\t\t\t", "\n\t\t\t", "\n\t\t}\n\t}\n"], ["\n\t", " \n\t", "\n\t.tws-rte-editor {\n\t\t\t", "\n\t\t\t", "\n\t\t}\n\t}\n"])), EditorStyles_1.ToolBarStyle, function (props) {
    return props.inputType === 'input'
        ? "\n\t\twidth: 100%;\n\t"
        : "\n\t".concat(props.maxWidth
            ? "\n\t\tmax-width: ".concat(props.maxWidth, ";")
            : '', "\n\t").concat(props.width
            ? "\n\t\twidth: ".concat(props.width, ";")
            : '', "\n\t");
}, function (props) { return (0, EditorStyles_1.EditorStyle)(props.minHeight, props.maxHeight); }, function (props) {
    return props.inputType === 'input'
        ? "\n\t\t\t\tmin-height: 0;\n\t\t\t\tmax-height: 54px;\n\t\t\t\toverflow-y: hidden;\n\n\t\t\t\t.public-DraftEditor-content, .public-DraftStyleDefault-block {\n\t\t\t\t\tpadding-bottom: 3px;\n\t\t\t\t}\n\t\t\t\t.public-DraftStyleDefault-block span {\n\t\t\t\t\twhite-space: nowrap!important;\n\t\t\t\t}"
        : '';
});
RichTextEditorContainer.displayName = 'RichTextEditorContainer';
var RichTextEditor = /** @class */ (function (_super) {
    __extends(RichTextEditor, _super);
    function RichTextEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.editorRef = null;
        _this.onChange = function (editor) {
            var onChange = _this.props.onChange;
            if (onChange) {
                var value = editor.editor.getData();
                _this.setState({ editorValue: value });
                onChange(value);
            }
        };
        _this.state = {
            editorValue: props.value,
        };
        return _this;
    }
    RichTextEditor.prototype.componentDidUpdate = function (prevProps) {
        if (this.editorRef && prevProps.value !== this.props.value && this.props.value !== this.state.editorValue) {
            this.setState({ editorValue: this.props.value });
            this.editorRef.editor.setData(this.props.value);
        }
    };
    RichTextEditor.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, readOnly = _a.readOnly, onBlur = _a.onBlur, onFocus = _a.onFocus, onPaste = _a.onPaste, mode = _a.mode, rest = __rest(_a, ["className", "readOnly", "onBlur", "onFocus", "onPaste", "mode"]);
        var editorValue = this.state.editorValue;
        var toolbarClass = 'tws-rte-toolbar toolbar-' + mode + '-mode';
        return (React.createElement(RichTextEditorContainer, __assign({}, rest, { onPaste: onPaste, className: "tws-rte-wrapper ".concat(className) }),
            React.createElement(GlobalCKEStyle, null),
            React.createElement(ckeditor4_react_1.CKEditor, { editorUrl: constants_1.default.CKEditorFullUrl, initData: React.createElement(React.Fragment, null, (0, html_react_parser_1.default)(editorValue || '')), wrapperClassName: 'tws-rte-wrapper', bodyClass: 'tws-rte-editor', readOnly: readOnly, toolbarClassName: toolbarClass, config: this.getConfig(), onBlur: onBlur, onFocus: onFocus, onChange: this.onChange, onInstanceReady: function (editor) {
                    if (editor.editor.document.$) {
                        editor.editor.document.$.body.style.margin = '10px';
                    }
                    _this.editorRef = editor;
                } }),
            this.getExtraMessage()));
    };
    RichTextEditor.prototype.getConfig = function () {
        var _a = this.props, height = _a.height, inputType = _a.inputType, mode = _a.mode, placeholder = _a.placeholder, toolbar = _a.toolbar;
        var config = {};
        switch (mode) {
            case 'basic':
                config = __assign({}, constants_1.default.EDITOR_DEFAULT_MODE);
                break;
            case 'full':
                config = __assign({}, constants_1.default.EDITOR_FULL_MODE);
                break;
            case 'custom':
                config = __assign({}, toolbar);
                break;
        }
        return __assign(__assign({}, config), { editorplaceholder: placeholder, height: inputType === 'input' ? '54px' : height });
    };
    RichTextEditor.prototype.getExtraMessage = function () {
        var _a = this.props, error = _a.error, messages = _a.messages;
        if (error) {
            return MessageHelper_1.MessageHelper.getFormattedErrorMessages(messages);
        }
        return null;
    };
    RichTextEditor.defaultProps = {
        mode: 'basic',
        inputType: 'textarea',
    };
    return RichTextEditor;
}(React.Component));
exports.RichTextEditor = RichTextEditor;
var templateObject_1, templateObject_2;
